export * from "./search_input";

export const AUTOCOMPLETE_ACTION_ICON_ID = "autocomplete-action-icon";
